export default __webpack_public_path__ + "static/media/counterSinkIcon.43bde52d.webp";